<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__number><div class="table-default__left">Number</div></template>
      <template #number="{ row }"><div class="table-default__left">{{ row.number }}</div></template>
      <template #group="{ row }">{{ row.group.name }}</template>
      <template #type="{ row }">{{ row.type.name }}</template>
      <template #supplier="{ row }">{{ row.supplier.legal_name }}</template>
      <template #dates="{ row }">
        {{ dateFormat(row.start) }} - {{ dateFormat(row.finish) }}
      </template>
      <template #amount_paid="{ row }">
        {{ row.amount_paid.toLocaleString() }} {{ row.amount_paid_currency.code }}
      </template>
      <template #attachment="{ row }">
        <div class="table-default__controls">
          <button
            @click="downloadFile(row.attachment, row)"
            type="button"
            :class="{'table-default__disabled': !row.attachment}"
          >
            <img src="@/assets/img/download-table-blue-icon.svg" alt="">
          </button>
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="$emit('openCreateModal', row)" type="button"><img src="@/assets/img/edit-table-icon.svg" alt="Edit"></button>
          <button @click="$emit('showDeleteModal', row.id)" type="button"><img src="@/assets/img/delete-table-icon.svg" alt="Delete"></button>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
export default {
  name: 'TableLicenses',
  props: ['tableItems', 'pagination', 'tablePreloader', 'dateFormat', 'downloadFile'],
  data() {
    return {
      table: {
        columns: ['number', 'group', 'type', 'supplier', 'dates', 'amount_paid', 'attachment'],
        options: {
          headings: {
            number: 'Number',
            group: 'Group',
            type: 'Type',
            supplier: 'Supplier',
            dates: 'Dates',
            amount_paid: 'Amount paid',
            attachment: 'Attachment',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    if (this.$store.state.userGroups.map(item => item.code).includes('general_manager')) this.table.columns.push('controls')
  }
}
</script>
